import React, { useState, useEffect } from 'react';
import './styles.css';
import cerrar from '../../../../static/img/cerrar.svg';
import profilePlaceHolder from '../../../../static/img/profilePlaceHolder.svg';
import CuadroTexto from '../../../../static/assets/cuadroTexto/cuadroTexto';
import LoadingScreen from '../../../../static/assets/loadingScreen/loadingScreen';
import IconoInstagram from '../../../../static/assets/icons/instagramIcon';
import IconoContacto from '../../../../static/assets/icons/whatsAppIcon';
import {
  getTrainerInfo,
  getUserInfo,
  cancelarEntrenamiento,
  solicitarEntrenamiento
} from '../../../../services/deportistaApi';
import PlanModal from '../planesEntrenador/plan';
import config from '../../../../config';
import { sendNotification } from '../../../../services/utilsApi';

const PerfilEntrenador = ({
  trainerId,
  deportistasAsignados,
  loggedUserId,
  onClose,
}) => {
  const [isClosing, setIsClosing] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [trainerData, setTrainerData] = useState({
    nombre: '',
    apellido: '',
    foto: 'default',
    celular: 'No disponible',
    instagram: 'No disponible',
    descripcion: '',
    planes_asignados: [],
    deportistas_asignados: [],
  });
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isPlanModalOpen, setIsPlanModalOpen] = useState(false);
  const [isEnrolled, setIsEnrolled] = useState(false);

  const [userName, setUserName] = useState('');
  const [userSurname, setUserSurname] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const response = await getTrainerInfo(trainerId);
        if (response.data.success) {
          const data = response.data.entrenador;
          setTrainerData({
            nombre: data.nombre,
            apellido: data.apellido,
            foto: data.foto || '',
            celular: data.celular || 'No disponible',
            instagram: data.instagram || 'No disponible',
            descripcion: data.descripcion,
            planes_asignados: data.planes_asignados || [],
            deportistas_asignados: data.deportistas_asignados || [],
          });
        } else {
          setDialogMessage('No se pudieron cargar los datos del entrenador.');
        }
      } catch {
        setDialogMessage('No se pudieron cargar los datos del entrenador.');
      } finally {
        setLoading(false);
      }
    })();
  }, [trainerId]);

  useEffect(() => {
    if (deportistasAsignados?.some((d) => d.id === loggedUserId)) {
      setIsEnrolled(true);
    }
  }, [deportistasAsignados, loggedUserId]);

  useEffect(() => {
    if (!loggedUserId) return;
    (async () => {
      try {
        const {
          data: { perfil },
        } = await getUserInfo(loggedUserId);
        setUserName(perfil.nombre);
        setUserSurname(perfil.apellido);
      } catch {
        setDialogMessage('No se pudo obtener el perfil del usuario.');
      }
    })();
  }, [loggedUserId]);

  if (loading) {
    return <LoadingScreen />;
  }

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(onClose, 300);
  };

  const handleRequestToggle = async () => {
    const fullName = `${userName} ${userSurname}`;
    const apiFn = isEnrolled ? cancelarEntrenamiento : solicitarEntrenamiento;
    const asunto = isEnrolled
      ? 'Cancelación de entrenamiento'
      : 'Solicitud de entrenamiento';
    const mensaje = isEnrolled
      ? `${fullName} ha decidido dejar de entrenar contigo.`
      : `${fullName} quiere comenzar un entrenamiento contigo.`;

    try {
      const resp = await apiFn(trainerId);
      if (resp.data.success) {
        setDialogMessage(resp.data.message);
        if (resp.data.success && !resp.data.duplicate) {
          try {
            await sendNotification({
              id_desde: loggedUserId,
              id_hasta: trainerId,
              asunto,
              mensaje,
              id_tipo: 1,
              visto: false,
            });
          } catch {
            setDialogMessage(
              'Se completó la operación, pero no se pudo notificar al entrenador.'
            );
          }
        }
        if (isEnrolled) {
          setIsEnrolled(false);
        }
      } else {
        setDialogMessage(resp.data.message || 'Operación fallida.');
      }
    } catch {
      setDialogMessage('Ocurrió un error al comunicarse con el servidor.');
    }
  };

  return (
    <div className={`perfil-entrenador-modal ${isClosing ? 'closing' : ''}`}>
      {dialogMessage && (
        <CuadroTexto
          message={dialogMessage}
          onAccept={() => setDialogMessage('')}
          showCancel={false}
        />
      )}

      <button className="perfil-entrenador-cerrar" onClick={handleClose}>
        <img src={cerrar} alt="cerrar" />
      </button>

      <div className="perfil-entrenador-content">
        <div className="perfil-entrenador-header">
          <div
            className={`perfil-entrenador-avatar ${
              !trainerData.foto || trainerData.foto.includes('default')
                ? ''
                : 'with-photo'
            }`}
          >
            <img
              alt={`${trainerData.nombre} ${trainerData.apellido}`}
              src={
                !trainerData.foto || trainerData.foto.includes('default')
                  ? profilePlaceHolder
                  : trainerData.foto
              }
            />
          </div>
          <h2 className="perfil-entrenador-name">
            {trainerData.nombre} {trainerData.apellido}
          </h2>
        </div>

        <div className="perfil-entrenador-contact">
          <button
            className={`contact-item ${
              trainerData.celular === 'No disponible'
                ? 'contact-item-empty'
                : 'contact-item-filled'
            }`}
            disabled={trainerData.celular === 'No disponible'}
            onClick={() => {
              const phone = trainerData.celular.replace(/[^0-9]/g, '');
              window.open(`${config.WHATSAPP_URL}${phone}`, '_blank');
            }}
          >
            <span>Contactar</span>
            <IconoContacto isActive={trainerData.celular !== 'No disponible'} />
          </button>

          <button
            className={`contact-item ${
              trainerData.instagram === 'No disponible'
                ? 'contact-item-empty'
                : 'contact-item-filled'
            }`}
            disabled={trainerData.instagram === 'No disponible'}
            onClick={() =>
              window.open(
                `${config.INSTAGRAM_URL}${trainerData.instagram}`,
                '_blank'
              )
            }
          >
            <span>Instagram</span>
            <IconoInstagram
              isActive={trainerData.instagram !== 'No disponible'}
            />
          </button>
        </div>

        <div className="perfil-entrenador-description">
          <div className="descripcion-title">Descripción:</div>
          <p>{trainerData.descripcion}</p>
        </div>

        <div className="perfil-entrenador-plans">
          <h3>Planes</h3>
          <div className="plans-container">
            {trainerData.planes_asignados.map((plan) => (
              <div
                key={plan.id}
                className="plan-card"
                onClick={() => {
                  setSelectedPlan(plan);
                  setIsPlanModalOpen(true);
                }}
              >
                <span className="nombre-plan-entrenador">{plan.nombre}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="perfil-entrenador-athletes">
          <h4>Atletas:</h4>
          <div className="athletes-container">
            {trainerData.deportistas_asignados.map((atleta) => (
              <div
                key={atleta.id}
                className={`athlete-avatar ${
                  !atleta.foto || atleta.foto.includes('default')
                    ? 'default-background'
                    : ''
                }`}
              >
                <img
                  src={
                    !atleta.foto || atleta.foto.includes('default')
                      ? profilePlaceHolder
                      : atleta.foto
                  }
                  alt={`${atleta.nombre} ${atleta.apellido}`}
                  className={
                    !atleta.foto || atleta.foto.includes('default')
                      ? 'default-img'
                      : 'full-img'
                  }
                />
              </div>
            ))}
          </div>
        </div>

        <button
          className={`perfil-entrenador-request-button ${
            isEnrolled ? 'cancelar' : 'solicitar'
          }`}
          onClick={handleRequestToggle}
        >
          {isEnrolled ? 'Cambiar entrenador' : 'Enviar solicitud'}
        </button>
      </div>

      {isPlanModalOpen && (
        <PlanModal
          plan={selectedPlan}
          onClose={() => setIsPlanModalOpen(false)}
        />
      )}
    </div>
  );
};

export default PerfilEntrenador;
